import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";

import { ScanForm } from "../components";
import { useScan, useUpdateScan } from "../hooks";

type IUpdateScan = {
  id: string;
};

export const UpdateScan: React.FC = () => {
  const { id } = useParams<IUpdateScan>();
  const navigate = useNavigate();
  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useScan(+id!);
  const { form, submit, loading } = useUpdateScan({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("Le scan a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.scan?.ok && data?.scan?.result) {
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }
  return (
    <>
      <Header
        title="Scan"
        subtitle="Modifier le scan"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: "/scans",
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <ScanForm loading={loading} submit={submit} form={form} />
      </div>
    </>
  );
};
